import Blog from "../Components/Blog";
import AddBlog from "../Components/Blog/AddBlog";
import UpdateBlog from "../Components/Blog/UpdateBlog";
import Career from "../Components/Career";
import FAQ from "../Components/FAQ";
import Addcareer from "../Components/Career/AddCareer";
import UpdateCareer from "../Components/Career/UpdateCareer";
import Client from "../Components/Client";
import News from "../Components/News";
import Addnews from "../Components/News/AddNews";
import Newsupdate from "../Components/News/UpdateNews";
import Partners from "../Components/Partners";
import Testimonials from "../Components/Testimonials";
import AddFAQ from "../Components/FAQ/AddFAQ";
import Book from "../Components/Book";
import AddBook from "../Components/Book/AddBook";
import Category from "../Components/Category";
import AddCategory from "../Components/Category/AddCategory";
import SubCategory from "../Components/SubCategory";
import AddSubCategory from "../Components/SubCategory/AddSubCategory";
import ContactUs from "../Components/ContactUs";
import Comments from "../Components/Comments";
import PosPage from "../Components/Pages/Pos";
import CMS from "../Components/CMS";
import AddCMS from "../Components/CMS/ManageCMS";
/* import AddFAQPages from "../Components/FAQ/page Details"; */
import FAQpages from "../Components/FAQPages";
import AddFAQPage from "../Components/FAQPages/AddFaqPages";
import Gallery from "../Components/Gallery";
import AddGallery from "../Components/Gallery/AddGallery";
import GalleryImage from "../Components/GalleryImage";
import AddGalleryImage from "../Components/GalleryImage/AddGalleryImage";
import Slider from "../Components/Slider";
import AddSlider from "../Components/Slider/AddSlider";
import Project from "../Components/Project";
import AddProject from "../Components/Project/AddProject";
import ProjectDetails from "../AddProjectDetails";
import AddProjectDetails from "../AddProjectDetails/AddProject";
import MetaPages from "../Components/Meta";
import AddMetaPages from "../Components/Meta/AddMetaPages";
import MetaDetails from "../Components/Metadetails";
import AddMetaDetails from "../Components/Metadetails/MetaAddDetails";
import ProjectCategory from "../Components/ProjectCategory";
import AddProjectCategory from "../Components/ProjectCategory/AddProjectcategory";
import AddSpesficProjectDetails from "../Components/Project/AddProjectDetailesByCategory/AddProjectDetailesByCategoryAdd";
import ProjectListDeatilesByCategory from "../Components/Project/AddProjectDetailesByCategory";
import AdSenseForm from "../Components/GoogleAdsence";
import FacebooxPixelForm from "../Components/FaceBookPixal";
import Event from "../Components/Event";
import AddEvent from "../Components/Event/AddEvent";
import Eventupdate from "../Components/Event/UpdateEvent";
import YoutubeFolder from "../Components/YoutubeFolder";
import AddYoutubeFolder from "../Components/YoutubeFolder/AddYoutubeFolder";
import YoutubeLink from "../Components/YoutubeFolder/YoutubeLinks";
import AddYoutubeLinks from "../Components/YoutubeFolder/YoutubeLinks/AddYoutubeLinks";
import TransactionFeed from "../Components/TransactionFeed";
import KYCStatus from "../Components/KYCStatus";
import UserDatabase from "../Components/UserDatabase";
import StoreHub from "../Components/StoreHub";
import AppBuilder from "../Components/AppBuilder";
import PolicyAndPrivecy from "../Components/PolicyPrivacy/PolicyPrivacyData";
import ReturnPolicyAndPrivecy from "../Components/PolicyPrivacy/ReturnRefandPolicy";
import CMS2 from "../Components/CMS2";
import AddCMS2 from "../Components/CMS2/ManageCMS";

import PagesName from "../Components/PageName";
import Menu from "../Components/Menu";
import SubMenu from "../Components/Menu/SubMenu";
import SubSubMenu from "../Components/Menu/SubSubMenu";
import AddPage from "../Components/PageName/AddFaqPages";
import Customization from "../Components/Customizations";
import ChatAgent from "../Components/ChatAgent";
import ChatAgentQuestionAnswer from "../Components/ChatAgent/QuestionAnswerByAgent";
import AddQuestionAnswer from "../Components/ChatAgent/QuestionAnswerByAgent/AddQAByAgent";
import ChatBotMessages from "../Components/ChatAgent/Chatbotmessages";
import ImagesComponent from "../Components/Images";
import UnMatchedSearch from "../Components/ChatAgent/UnmatchedSearch";
import AllImagesComponent from "../Components/AllImages";
import { useLocation } from "react-router-dom";
import BuilderPage from "../BuilderPage";
import WaitingChatUser from "../Components/ChatAgent/WaitingChatUser";
import CaseStudy from "../Components/CaseStudy";
import AddCaseStudy from "../Components/CaseStudy/AddCaseStudy";
import PageDesignSetup from "../Components/PageDesignSetup";
import AddPageDesign from "../Components/PageDesignSetup/AddPageDesign";
import Document from "../Components/Document";
import AddDocument from "../Components/Document/AddDocument";

export const routes = [
  {
    id: 1,
    path: "/blog",
    component: <Blog />,
  },
  {
    id: 2,
    path: "/addblog",
    component: <AddBlog />,
  },
  {
    id: 3,
    path: "/updateblog",
    component: <UpdateBlog />,
  },
  {
    id: 4,
    path: "/news",
    component: <News />,
  },
  {
    id: 5,
    path: "/addnews",
    component: <Addnews />,
  },
  {
    id: 6,
    path: "/newsupdate/:id",
    component: <Newsupdate />,
  },
  {
    id: 7,
    path: "/career",
    component: <Career />,
  },
  {
    id: 8,
    path: "/addcareer",
    component: <Addcareer />,
  },
  {
    id: 9,
    path: "/updateCareer/:id",
    component: <UpdateCareer />,
  },
  {
    id: 10,
    path: "/testimonials",
    component: <Testimonials />,
  },
  {
    id: 11,
    path: "/clients",
    component: <Client />,
  },
  {
    id: 11_1,
    path: "/comments",
    component: <Comments />,
  },
  {
    id: 12,
    path: "/partners",
    component: <Partners />,
  },
  {
    id: 13,
    path: "/faq/:id",
    component: <FAQ />,
  },
  {
    id: 14,
    path: "/faq/:id/:type",
    component: <AddFAQ />,
  },
  {
    id: 15,
    path: "/book",
    component: <Book />,
  },
  {
    id: 16,
    path: "/book/:type",
    component: <AddBook />,
  },
  {
    id: 17,
    path: "/category",
    component: <Category />,
  },
  {
    id: 18,
    path: "/category/:type",
    component: <AddCategory />,
  },
  {
    id: 19,
    path: "/sub-category",
    component: <SubCategory />,
  },
  {
    id: 20,
    path: "/sub-category/:type",
    component: <AddSubCategory />,
  },
  {
    id: 21,
    path: "/contact-us",
    component: <ContactUs />,
  },
  {
    id: 22,
    path: "/pos",
    component: <PosPage />,
  },
  {
    id: 23,
    path: "/cms",
    component: <CMS />,
  },
  {
    id: 14,
    path: "/cms/:type",
    component: <AddCMS />,
  },

  {
    id: 23,
    path: "/cms2",
    component: <CMS2 />,
  },
  {
    id: 14,
    path: "/cms2/:type",
    component: <AddCMS2 />,
  },
  /*   {
      id: 15,
      path: "/faq/addpages/:id",
      component: <AddFAQPages />
    }, */
  {
    id: 17,
    path: "/faq-pages",
    component: <FAQpages />,
  },
  {
    id: 18,
    path: "/faq-pages/:type",
    component: <AddFAQPage />,
  },
  {
    id: 19,
    path: "/gallery",
    component: <Gallery />,
  },
  {
    id: 20,
    path: "/gallery/:type",
    component: <AddGallery />,
  },
  {
    id: 22,
    path: "/gallery-image",
    component: <GalleryImage />,
  },
  {
    id: 23,
    path: "/gallery-image/:state",
    component: <AddGalleryImage />,
  },
  {
    id: 24,
    path: "/slider",
    component: <Slider />,
  },
  {
    id: 25,
    path: "/slider/:type",
    component: <AddSlider />,
  },
  {
    id: 26,
    path: "/project",
    component: <Project />,
  },
  {
    id: 27,
    path: "/project/:type",
    component: <AddProject />,
  },
  {
    id: 28,
    path: "/projectdetails/:id",
    component: <ProjectDetails />,
  },
  {
    id: 29,
    path: "/projectdetails/:id/:type",
    component: <AddProjectDetails />,
  },
  {
    id: 30,
    path: "/meta",
    component: <MetaPages />,
  },

  {
    id: 31,
    path: "/meta/:type",
    component: <AddMetaPages />,
  },
  {
    id: 28,
    path: "/metadetails/:id",
    component: <MetaDetails />,
  },
  {
    id: 29,
    path: "/metadetails/:id/:type",
    component: <AddMetaDetails />,
  },

  {
    id: 30,
    path: "/project_category",
    component: <ProjectCategory />,
  },
  {
    id: 31,
    path: "/project_category/:type",
    component: <AddProjectCategory />,
  },

  {
    id: 32,
    path: "/addspesficprojectdetails/:id",
    component: <ProjectListDeatilesByCategory />,
  },
  {
    id: 33,
    path: "/addspesficprojectdetails/:id/:type",
    component: <AddSpesficProjectDetails />,
  },

  {
    id: 34,
    path: "/adsence",
    component: <AdSenseForm />,
  },

  {
    id: 35,
    path: "/facebookpixal",
    component: <FacebooxPixelForm />,
  },

  {
    id: 36,
    path: "/event",
    component: <Event />,
  },
  {
    id: 37,
    path: "/addevent",
    component: <AddEvent />,
  },
  {
    id: 38,
    path: "/eventupdate/:id",
    component: <Eventupdate />,
  },

  {
    id: 39,
    path: "/youtube-folder",
    component: <YoutubeFolder />,
  },
  {
    id: 20,
    path: "/youtube-folder/:type",
    component: <AddYoutubeFolder />,
  },
  {
    id: 22,
    path: "/youtube-links",
    component: <YoutubeLink />,
  },
  {
    id: 23,
    path: "/youtube-links/:state",
    component: <AddYoutubeLinks />,
  },
  {
    id: 24,
    path: "/transaction-feed",
    component: <TransactionFeed />,
  },
  {
    id: 25,
    path: "/kyc-status",
    component: <KYCStatus />,
  },
  {
    id: 26,
    path: "/user-database",
    component: <UserDatabase />,
  },
  {
    id: 27,
    path: "/storeHub",
    component: <StoreHub />,
  },

  {
    id: 27,
    path: "/content",
    component: <AppBuilder />,
  },

  {
    id: 29,
    path: "/policy-privacy",
    component: <PolicyAndPrivecy />,
  },

  {
    id: 30,
    path: "/return-and-refund-policy",
    component: <ReturnPolicyAndPrivecy />,
  },
  {
    id: 31,
    path: "/page",
    component: <PagesName />,
  },
  {
    id: 32,
    path: "/menu",
    component: <Menu />,
  },
  {
    id: 32,
    path: "/sub-menu",
    component: <SubMenu />,
  },
  {
    id: 33,
    path: "/sub-sub-menu",
    component: <SubSubMenu />,
  },

  {
    id: 33,
    path: "/page/:type",
    component: <AddPage />,
  },

  {
    id: 34,
    path: "/customizetion",
    component: <Customization />,
  },

  {
    id: 76,
    path: "/chat-agent",
    component: <ChatAgent />,
  },

  {
    id: 77,
    path: "/chat-agent/question-answer",
    component: <ChatAgentQuestionAnswer />,
  },

  {
    id: 78,
    path: "/chat-agent/question-answer/:type",
    component: <AddQuestionAnswer />,
  },

  {
    id: 79,
    path: "/chat-agent/chatbot-messages",
    component: <ChatBotMessages />,
  },

  {
    id: 80,
    path: "/images",
    component: <ImagesComponent />,
  },
  {
    id: 81,
    path: "/chat-agent/unmatched-search",
    component: <UnMatchedSearch />,
  },

  {
    id: 82,
    path: "/all-images",
    component: <AllImagesComponent />,
  },

  {
    id: 83,
    path: "/waiting-chatuser",
    component: <WaitingChatUser />,
  },
  {
    id: 84,
    path: "/case-study",
    component: <CaseStudy />,
  },

  {
    id: 85,
    path: "/case-study/add",
    component: <AddCaseStudy />,
  },
  {
    id: 86,
    path: "/case-study/:type",
    component: <AddCaseStudy />,
  },
  {
    id: 87,
    path: "/page-design-setup",
    component: <PageDesignSetup />,
  },
  // {
  //   id: 88,
  // path: "/page-design-setup/add",
  //   component: <PageDesignSetup />,
  // },
  {
    id: 87,
    path: "/page-design-setup/add",
    component: <AddPageDesign />,
    
  },
    {
    id: 88,
  path: "/page-design-setup/:type",
    component: <AddPageDesign />,
  },
   {
    id: 89,
    path: "/document",
    component: <Document />,
  },

  {
  id: 90,
  path: "/document/add",
  component: <AddDocument />,
},
{
  id: 91,
  path: "/document/:type",
  component: <AddDocument />,
},
];
